// import React, { useState, useEffect } from 'react';
// import './viewPort.css';
// import { useInvoice } from '../AuthContext';

// const ViewPort = () => {

//   const { invoiceNumber} = useInvoice();
//   const [invoice, setInvoice] = useState(null);
//   const [error, setError] = useState('');


//   useEffect(() => {
//     console.log(invoiceNumber); // log
//     const fetchInvoice = async () => {
//       try {
//         const response = await fetch(`http://invoice.dockyardsoftware.com/api/Invoice/${invoiceNumber}`);
//         if (!response.ok) {
//           throw new Error('Failed to fetch invoice');
//         }
//         const data = await response.json();
//         console.log('Fetched invoice data:', data); 
//         setInvoice(data);
//       } catch (error) {
//         setError(error.message);
//       }
//     };

//     fetchInvoice();
//   }, [invoiceNumber]);

//   if (error) {
//     return <div>Error: {error}</div>;
//   }

//   if (!invoice) {
//     return <div>Loading...</div>;
//   }


//   const items = invoice.items?.$values || [];
//   console.log('Items:', items);

//   const subtotal = items.reduce((acc, item) => acc + item.unitPrice * item.quantity, 0);
//   const discountAmount = (subtotal * invoice.discount) / 100;
//   const taxAmount = (subtotal * invoice.tax) / 100;

//   return (
//     <div className="invoice">
//       <h1>Invoice</h1>
//       <div className="invoice-header">
//         <div className="company-info">
//           <p>Company Name: {invoice.companyName}</p>
//           <p>Company Address: {invoice.companyAddress}</p>
//         </div>
//         <div className="invoice-details">
//           <p>Date Issued: {invoice.date}</p>
//           <p>Invoice Number: {invoice.invoiceNumber}</p>
//         </div>
//       </div>
//       <div className="invoice-body">
//         <div className="billing-info">
//           <p>Client Name: {invoice.clientName}</p>
//         </div>
//         <div className="table">
//           <div className="table-row table-header">
//             <div>Description</div>
//             <div>Rate</div>
//             <div>Qty</div>
//             <div>Amount</div>
//           </div>
//           {items.map((item, index) => (
//             <div className="table-row" key={index}>
//               <div>{item.productName}</div>
//               <div>{item.unitPrice}</div>
//               <div>{item.quantity}</div>
//               <div>{item.unitPrice * item.quantity}</div>
//             </div>
//           ))}
//         </div>
//       </div>
//       <div className="invoice-footer">
//         <div className="totals">
//           <p>Subtotal: {subtotal.toFixed(2)}</p>
//           <p>Discount: {invoice.discount}% ({discountAmount.toFixed(2)})</p>
//           <p>Tax: {invoice.tax}% ({taxAmount.toFixed(2)})</p>
//           <p>Total: {invoice.total}</p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ViewPort;

// import React, { useState, useEffect } from "react";
// import { useInvoice } from "../AuthContext";

// const ViewPort = () => {
//   const { invoiceNumber } = useInvoice();
//   const [invoice, setInvoice] = useState(null);
//   const [error, setError] = useState("");

//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     if (isNaN(date.getTime())) {
//       return "Invalid date"; // Or you can return an empty string or a default value
//     }
//     return date.toISOString().split("T")[0]; // Converts to YYYY-MM-DD format
//   };


//   useEffect(() => {
//     const fetchInvoice = async () => {
//       try {
//         const response = await fetch(`http://invoice.dockyardsoftware.com/api/Invoice/${invoiceNumber}`);
//         if (!response.ok) {
//           throw new Error("Failed to fetch invoice");
//         }
//         const data = await response.json();
//         setInvoice(data);
//       } catch (error) {
//         setError(error.message);
//       }
//     };

//     fetchInvoice();
//   }, [invoiceNumber]);

//   if (error) {
//     return <div>Error: {error}</div>;
//   }

//   if (!invoice) {
//     return <div>Loading...</div>;
//   }

//   const items = invoice.items?.$values || [];
//   const subtotal = items.reduce((acc, item) => acc + item.unitPrice * item.quantity, 0);
//   const discountAmount = (subtotal * invoice.discount) / 100;
//   const taxAmount = (subtotal * invoice.tax) / 100;
//   const total = subtotal - discountAmount + taxAmount;

//   const handlePrint = () => {
//     window.print();
//   };

//   return (
//     <div className="invoice print-only max-w-4xl p-6 border border-gray-300 mx-auto bg-white mt-20 mb-10">
//     <h1 className="text-3xl font-bold mb-6">INVOICE</h1>

//    {/* Header Section */}
// <div className="invoice-header grid grid-cols-2 gap-4 mb-8">
//   <div className="company-info text-sm">
//     <p><span className="font-bold">Business name:</span> DockyardTotal Solution</p>
//     <p><span className="font-bold">Address:</span> No 457/ Colombo</p>
//     <p><span className="font-bold">Phone number:</span> 011-234568</p>
//     <p><span className="font-bold">Email:</span> docyard@gmail.com</p>
//   </div>
//   <div className="invoice-details text-sm text-right">
//     <p><span className="font-bold">Invoice number:</span> {invoice.invoiceNumber}</p>
//     <p><span className="font-bold">Invoice date:</span> {formatDate(invoice.date)}</p>
//   </div>
// </div>


//       {/* Bill To Section */}
//       <div className="billing-info grid grid-cols-2 gap-4 mb-8">
//         <div className="text-sm">
//           <p className="font-bold">Bill to:</p>
//           <p>{invoice.clientName}</p>
//           <p>{invoice.clientAddress}</p>
//           <p>{invoice.clientPhoneNumber}</p>
//           <p>{invoice.clientEmail}</p>
//         </div>
//       </div>

//      {/* Table Section */}
// <div className="table w-full mb-8">
//   {/* Table Header */}
//   <div className="grid grid-cols-4 bg-orange-100 font-bold border-b-2 py-2">
//     <div className="text-left pl-2">Item</div>

//     <div className="text-center">Quantity</div>
//     <div className="text-center pr-2">Price per unit</div>
//     <div className="text-right pr-2">Amount</div>
//   </div>

//   {/* Table Rows */}
//   {items.map((item, index) => (
//     <div key={index} className="grid grid-cols-4 py-2 border-b">
//       <div className="text-left pl-2">{item.productName}</div>
//       <div className="text-right">{(item.unitPrice * item.quantity).toFixed(2)}</div>
//       <div className="text-center">{item.quantity.toFixed(2)}</div>
//       <div className="text-center pr-2">{item.unitPrice.toFixed(2)}</div>
//     </div>
//   ))}
// </div>


//       {/* Totals Section */}
//       <div className="totals text-sm text-right mb-8">
//         <p>Subtotal:  {subtotal.toFixed(2)}</p>
//         <p>Tax {invoice.tax}%:  {taxAmount.toFixed(2)}</p>
//         <p>Fees/discounts:  {discountAmount.toFixed(2)}</p>
//         <p className="font-bold text-lg">TOTAL: Rs {total.toFixed(2)}</p>
//       </div>

//       {/* Footer Section */}
//       <div className="footer text-sm">
//         <p className="font-bold">Terms and conditions</p>
//         <p>Terms and conditions go here</p>
//       </div>

// {/* Print Button */}
// <div className="print-button mt-6 print:hidden">
//   <button
//     onClick={handlePrint}
//     className="bg-blue-500 text-white py-2 px-4 rounded-lg shadow hover:bg-blue-700"
//   >
//     Print Invoice
//   </button>
// </div>
//     </div>
//   );
// };

// export default ViewPort;


// import React, { useState, useEffect } from "react";
// import { useInvoice } from "../AuthContext";

// const ViewPort = () => {
//   const { invoiceNumber } = useInvoice();
//   const [invoice, setInvoice] = useState(null);
//   const [error, setError] = "";

//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     return isNaN(date.getTime()) ? "Invalid date" : date.toISOString().split("T")[0];
//   };

//   useEffect(() => {
//     const fetchInvoice = async () => {
//       try {
//         const response = await fetch(`https://invoice.dockyardsoftware.com/api/Invoice/${invoiceNumber}`);
//         if (!response.ok) throw new Error("Failed to fetch invoice");
//         const data = await response.json();
//         setInvoice(data);
//       } catch (error) {
//         setError(error.message);
//       }
//     };

//     fetchInvoice();
//   }, [invoiceNumber]);

//   if (error) return <div>Error: {error}</div>;
//   if (!invoice) return <div>Loading...</div>;

//   const items = invoice.items?.$values || [];
//   const subtotal = items.reduce((acc, item) => acc + item.unitPrice * item.quantity, 0);
//   const discountAmount = (subtotal * invoice.discount) / 100;
//   const taxAmount = (subtotal * invoice.tax) / 100;
//   const total = subtotal - discountAmount + taxAmount;

//   const handlePrint = () => window.print();

//   return (
//     <div className="invoice print-only max-w-4xl p-6 border border-gray-300 mx-auto bg-white mt-10 mb-10">
//       <h1 className="text-3xl font-bold mb-6 text-center">INVOICE</h1>

//     {/* Header Section */}
// <div className="invoice-header grid grid-cols-1 md:grid-cols-2 gap-4 mb-8 border-b pb-4">
//   <div className="company-info text-sm">
//     <div className="grid grid-cols-2 gap-x-2">
//       <p className="font-bold">Business name:</p>
//       <p>DockyardTotal Solution</p>
//       <p className="font-bold">Address:</p>
//       <p>No 457/ Colombo</p>
//       <p className="font-bold">Phone number:</p>
//       <p>011-2345678</p>
//       <p className="font-bold">Email:</p>
//       <p>docyard@gmail.com</p>
//     </div>
//   </div>
//   <div className="invoice-details text-sm">
//     <div className="grid grid-cols-2 gap-x-2">
//       <p className="font-bold">Invoice number:</p>
//       <p>{invoice.invoiceNumber}</p>
//       <p className="font-bold">Invoice date:</p>
//       <p>{formatDate(invoice.date)}</p>
//     </div>
//   </div>
// </div>

//     {/* Bill To Section */}
// <div className="billing-info grid grid-cols-1 md:grid-cols-2 gap-4 mb-8 border-b pb-4">
//   <div className="text-sm">
//     <div className="grid grid-cols-2 gap-x-2">
//       <p className="font-bold">Name:</p>
//       <p>{invoice.clientName}</p>
//       {/* <p className="font-bold">Address:</p>
//       <p>{invoice.clientAddress}</p>
//       <p className="font-bold">Phone:</p>
//       <p>{invoice.clientPhoneNumber}</p>
//       <p className="font-bold">Email:</p>
//       <p>{invoice.clientEmail}</p> */}
//     </div>
//   </div>
// </div>

//     {/* Table Section */}
// <div className="table w-full mb-8 overflow-x-auto">
//   <table className="min-w-full border-collapse border border-gray-300">
//     {/* Table Header */}
//     <thead className="bg-orange-100 font-bold border-b-2 text-center">
//       <tr>
//         <th className="text-left pl-4 py-2 border border-gray-300">Item</th>
//         <th className="py-2 border border-gray-300">Quantity</th>
//         <th className="py-2 border border-gray-300">Price per unit</th>
//         <th className="text-right pr-4 py-2 border border-gray-300">Amount</th>
//       </tr>
//     </thead>

//     {/* Table Body */}
//     <tbody>
//       {items.map((item, index) => (
//         <tr key={index} className="border-b text-center">
//           <td className="text-left pl-4 py-2 border border-gray-300">{item.productName}</td>
//           <td className="py-2 border border-gray-300">{item.quantity.toFixed(2)}</td>
//           <td className="py-2 border border-gray-300">{item.unitPrice.toFixed(2)}</td>
//           <td className="text-right pr-4 py-2 border border-gray-300">{(item.unitPrice * item.quantity).toFixed(2)}</td>
//         </tr>
//       ))}
//     </tbody>
//   </table>
// </div>


//       {/* Totals Section */}
//       <div className="totals text-sm text-right border-t-2 border-gray-300 pt-4 w-full">
//         <div className="grid grid-cols-1 md:grid-cols-2">
//           <div></div>
//           <div className="text-right">
//             <p className="flex justify-between mr-4 md:ml-20"><span>Subtotal:</span> <span> {subtotal.toFixed(2)}</span></p>
//             <p className="flex justify-between mr-4 md:ml-20"><span>Tax {invoice.tax}%:</span> <span> {taxAmount.toFixed(2)}</span></p>
//             <p className="flex justify-between mr-4 md:ml-20"><span>Fees/discounts:</span> <span> {discountAmount.toFixed(2)}</span></p>
//             <p className="flex justify-between font-bold text-lg bg-orange-100 -px-25 py-2 md:ml-20 mr-2">
//               <span>TOTAL:</span> <span>Rs {total.toFixed(2)}</span>
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* Footer Section */}
//       <div className="footer text-sm mt-8">
//         <p className="font-bold">Terms and conditions</p>
//         <p>Terms and conditions go here</p>
//       </div>


//       {/* Print Button */}
//       <div className="print-button mt-6 print:hidden">
//         <button
//           onClick={handlePrint}
//           className="bg-blue-500 text-white py-2 px-4 rounded-lg shadow hover:bg-blue-700"
//         >
//           Print Invoice
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ViewPort;


// import React from "react";
// import { useLocation } from "react-router-dom";

// const ViewPort = () => {
//   const { state } = useLocation();
//   const { invoiceData } = state;
//   const handlePrint = () => window.print();

//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     return isNaN(date.getTime()) ? "Invalid date" : date.toISOString().split("T")[0];
//   };

//   const items = invoiceData.items || [];

//   const subtotal = items.reduce((acc, item) => acc + item.unitPrice * item.quantity, 0);
//   const discountAmount = (subtotal * (invoiceData.discount || 0)) / 100;
//   const taxAmount = (subtotal * (invoiceData.tax || 0)) / 100;
//   const total = subtotal - discountAmount + taxAmount;

//   return (
//     <div className="invoice print-only max-w-4xl p-6 border border-gray-300 mx-auto bg-white mt-10 mb-10">
//       <h1 className="text-3xl font-bold mb-6 text-center">INVOICE</h1>

//       {/* Header Section */}
//       <div className="invoice-header grid grid-cols-1 md:grid-cols-2 gap-4 mb-8 border-b pb-4">
//         <div className="company-info text-sm">
//           <div className="grid grid-cols-2 gap-x-2">
//             <p className="font-bold">Business name:</p>
//             <p>DockyardTotal Solution</p>
//             <p className="font-bold">Address:</p>
//             <p>No 457/ Colombo</p>
//             <p className="font-bold">Phone number:</p>
//             <p>011-2345678</p>
//             <p className="font-bold">Email:</p>
//             <p>docyard@gmail.com</p>
//           </div>
//         </div>
//         <div className="invoice-details text-sm">
//           <div className="grid grid-cols-2 gap-x-2">
//             <p className="font-bold">Invoice number:</p>
//             <p>{invoiceData.invoiceNumber}</p>
//             <p className="font-bold">Invoice date:</p>
//             <p>{formatDate(invoiceData.date)}</p>
//           </div>
//         </div>
//       </div>

//       {/* Bill To Section */}
//       <div className="billing-info grid grid-cols-1 md:grid-cols-2 gap-4 mb-8 border-b pb-4">
//         <div className="text-sm">
//           <div className="grid grid-cols-2 gap-x-2">
//             <p className="font-bold">Name:</p>
//             <p>{invoiceData.clientName}</p>
//           </div>
//         </div>
//       </div>

//       {/* Table Section */}
//       <div className="table w-full mb-8 overflow-x-auto">
//         <table className="min-w-full border-collapse border border-gray-300">
//           <thead className="bg-orange-100 font-bold border-b-2 text-center">
//             <tr>
//               <th className="text-left pl-4 py-2 border border-gray-300">Item</th>
//               <th className="py-2 border border-gray-300">Quantity</th>
//               <th className="py-2 border border-gray-300">Price per unit</th>
//               <th className="text-right pr-4 py-2 border border-gray-300">Amount</th>
//             </tr>
//           </thead>
//           <tbody>
//   {items.length > 0 ? (
//     items.map((item, index) => {
//       const quantity = Number(item.quantity) || 0; // Convert to number, default to 0
//       const unitPrice = Number(item.unitPrice) || 0; // Convert to number, default to 0
//       return (
//         <tr key={index} className="border-b text-center">
//           <td className="text-left pl-4 py-2 border border-gray-300">{item.productName}</td>
//           <td className="py-2 border border-gray-300">{quantity.toFixed(2)}</td>
//           <td className="py-2 border border-gray-300">{unitPrice.toFixed(2)}</td>
//           <td className="text-right pr-4 py-2 border border-gray-300">
//             {(unitPrice * quantity).toFixed(2)}
//           </td>
//         </tr>
//       );
//     })
//   ) : (
//     <tr>
//       <td colSpan="4" className="text-center py-4">No items found</td>
//     </tr>
//   )}
// </tbody>

//         </table>
//       </div>

//       {/* Totals Section */}
//       <div className="totals text-sm text-right border-t-2 border-gray-300 pt-4 w-full">
//         <div className="grid grid-cols-1 md:grid-cols-2">
//           <div></div>
//           <div className="text-right">
//             <p className="flex justify-between mr-4 md:ml-20">
//               <span>Subtotal:</span> <span>Rs {subtotal.toFixed(2)}</span>
//             </p>
//             <p className="flex justify-between mr-4 md:ml-20">
//               <span>Tax ({invoiceData.tax || 0}%):</span> <span>Rs {taxAmount.toFixed(2)}</span>
//             </p>
//             <p className="flex justify-between mr-4 md:ml-20">
//               <span>Fees/discounts:</span> <span>Rs {discountAmount.toFixed(2)}</span>
//             </p>
//             <p className="flex justify-between font-bold text-lg bg-orange-100 px-4 py-2 md:ml-20 mr-2">
//               <span>TOTAL:</span> <span>Rs {total.toFixed(2)}</span>
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* Footer Section */}
//       <div className="footer text-sm mt-8">
//         <p className="font-bold">Terms and conditions</p>
//         <p>Terms and conditions go here</p>
//       </div>

//       {/* Print Button */}
//       <div className="print-button mt-6 print:hidden">
//         <button
//           onClick={handlePrint}
//           className="bg-blue-500 text-white py-2 px-4 rounded-lg shadow hover:bg-blue-700"
//         >
//           Print Invoice
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ViewPort;


// import React from "react";
// import { useLocation } from "react-router-dom";

// const ViewPort = () => {
//   const { state } = useLocation();
//   const { invoiceData } = state;
//   const handlePrint = () => window.print();

//   // Function to clean invoice number by removing the part after a hyphen
//   const cleanInvoiceNumber = (invoiceNumber) => {
//     if (invoiceNumber.includes("-")) {
//       return invoiceNumber.split("-")[0]; // Take the part before the hyphen
//     }
//     return invoiceNumber; // Return as-is if no hyphen
//   };

//   // Log invoiceData to debug the issue
//   console.log(invoiceData);

//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     return isNaN(date.getTime()) ? "Invalid date" : date.toISOString().split("T")[0];
//   };

//   const items = invoiceData.items || [];

//   const subtotal = items.reduce((acc, item) => acc + item.unitPrice * item.quantity, 0);
//   const discountAmount = (subtotal * (invoiceData.discount || 0)) / 100;
//   const taxAmount = (subtotal * (invoiceData.tax || 0)) / 100;
//   const total = subtotal - discountAmount + taxAmount;


//   // Check if Advance Amount field should be shown
//   const showAdvanceAmount = String(cleanInvoiceNumber(invoiceData.invoiceNumber)) === String(invoiceData.invoiceNumber);

//   const advanceAmount = Number(invoiceData.advanceAmount) || 0;

//   // Log the cleaned invoice number
//   console.log("Cleaned Invoice Number:", cleanInvoiceNumber(invoiceData.invoiceNumber));


//   return (
//     <div className="invoice print-only max-w-4xl p-6 border border-gray-300 mx-auto bg-white mt-10 mb-10">
//       <h1 className="text-3xl font-bold mb-6 text-center">INVOICE</h1>

//       {/* Header Section */}
//       <div className="invoice-header grid grid-cols-1 md:grid-cols-2 gap-4 mb-8 border-b pb-4">
//         <div className="company-info text-sm">
//           <div className="grid grid-cols-2 gap-x-2">
//             <p className="font-bold">Business name:</p>
//             <p>DockyardTotal Solution</p>
//             <p className="font-bold">Address:</p>
//             <p>No 457/ Colombo</p>
//             <p className="font-bold">Phone number:</p>
//             <p>011-2345678</p>
//             <p className="font-bold">Email:</p>
//             <p>docyard@gmail.com</p>
//           </div>
//         </div>
//         <div className="invoice-details text-sm">
//           <div className="grid grid-cols-2 gap-x-2">
//             <p className="font-bold">Invoice number:</p>
//             <p>{invoiceData.invoiceNumber}</p>
//             <p className="font-bold">Invoice number:</p>
//             <p>{cleanInvoiceNumber(invoiceData.invoiceNumber)}</p>
//             <p className="font-bold">Invoice date:</p>
//             <p>{formatDate(invoiceData.date)}</p>
//           </div>
//         </div>
//       </div>

//       {/* Bill To Section */}
//       <div className="billing-info grid grid-cols-1 md:grid-cols-2 gap-4 mb-8 border-b pb-4">
//         <div className="text-sm">
//           <div className="grid grid-cols-2 gap-x-2">
//             <p className="font-bold">Name:</p>
//             <p>{invoiceData.clientName}</p>
//           </div>
//         </div>
//       </div>

//       {/* Table Section */}
//       <div className="table w-full mb-8 overflow-x-auto">
//         <table className="min-w-full border-collapse border border-gray-300">
//           <thead className="bg-orange-100 font-bold border-b-2 text-center">
//             <tr>
//               <th className="text-left pl-4 py-2 border border-gray-300">Item</th>
//               <th className="py-2 border border-gray-300">Quantity</th>
//               <th className="py-2 border border-gray-300">Price per unit</th>
//               <th className="text-right pr-4 py-2 border border-gray-300">Amount</th>
//             </tr>
//           </thead>
//           <tbody>
//             {items.length > 0 ? (
//               items.map((item, index) => {
//                 const quantity = Number(item.quantity) || 0; // Convert to number, default to 0
//                 const unitPrice = Number(item.unitPrice) || 0; // Convert to number, default to 0
//                 return (
//                   <tr key={index} className="border-b text-center">
//                     <td className="text-left pl-4 py-2 border border-gray-300">{item.productName}</td>
//                     <td className="py-2 border border-gray-300">{quantity.toFixed(2)}</td>
//                     <td className="py-2 border border-gray-300">{unitPrice.toFixed(2)}</td>
//                     <td className="text-right pr-4 py-2 border border-gray-300">
//                       {(unitPrice * quantity).toFixed(2)}
//                     </td>
//                   </tr>
//                 );
//               })
//             ) : (
//               <tr>
//                 <td colSpan="4" className="text-center py-4">No items found</td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Totals Section */}
//       <div className="totals text-sm text-right border-t-2 border-gray-300 pt-4 w-full">
//         <div className="grid grid-cols-1 md:grid-cols-2">
//           <div></div>
//           <div className="text-right">
//             <p className="flex justify-between mr-4 md:ml-20">
//               <span>Subtotal:</span> <span>Rs {subtotal.toFixed(2)}</span>
//             </p>

//             {showAdvanceAmount && (
//               <p className="flex justify-between mr-4 md:ml-20">
//                 <span>Advance Amount:</span> <span>Rs {advanceAmount.toFixed(2)}</span>
//               </p>
//             )}

//             <p className="flex justify-between mr-4 md:ml-20">
//               <span>Tax ({invoiceData.tax || 0}%):</span> <span>Rs {taxAmount.toFixed(2)}</span>
//             </p>


//             <p className="flex justify-between mr-4 md:ml-20">
//               <span>Fees/discounts:</span> <span>Rs {discountAmount.toFixed(2)}</span>
//             </p>

//             <p className="flex justify-between mr-4 md:ml-20">
//               <span>Tax ({invoiceData.tax || 0}%):</span> <span>Rs {paidAmount.toFixed(2)}</span>
//             </p>
//             <p className="flex justify-between font-bold text-lg bg-orange-100 px-4 py-2 md:ml-20 mr-2">
//               <span>TOTAL:</span> <span>Rs {total.toFixed(2)}</span>
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* Footer Section */}
//       <div className="footer text-sm mt-8">
//         <p className="font-bold">Terms and conditions</p>
//         <p>Terms and conditions go here</p>
//       </div>

//       {/* Print Button */}
//       <div className="print-button mt-6 print:hidden">
//         <button
//           onClick={handlePrint}
//           className="bg-blue-500 text-white py-2 px-4 rounded-lg shadow hover:bg-blue-700"
//         >
//           Print Invoice
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ViewPort;


// import React from "react";
// import { useLocation } from "react-router-dom";

// const ViewPort = () => {
//   const { state } = useLocation();
//   const { invoiceData } = state;
//   const handlePrint = () => window.print();


//   // Function to clean invoice number by removing the part after a hyphen
//   const cleanInvoiceNumber = (invoiceNumber) => {
//     if (invoiceNumber.includes("-")) {
//       return invoiceNumber.split("-")[0]; // Take the part before the hyphen
//     }
//     return invoiceNumber; // Return as-is if no hyphen
//   };

//   // Log invoiceData to debug the issue
//   console.log(invoiceData);

//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     return isNaN(date.getTime()) ? "Invalid date" : date.toISOString().split("T")[0];
//   };

//   const items = invoiceData.items || [];

//   const subtotal = items.reduce((acc, item) => acc + item.unitPrice * item.quantity, 0);
//   const discountAmount = (subtotal * (invoiceData.discount || 0)) / 100;
//   const taxAmount = (subtotal * (invoiceData.tax || 0)) / 100;
//   const total = subtotal - discountAmount + taxAmount;


//   // Check if Advance Amount field should be shown
//   const showAdvanceAmount = String(cleanInvoiceNumber(invoiceData.invoiceNumber)) === String(invoiceData.invoiceNumber);

//   const advanceAmount = Number(invoiceData.advanceAmount) || 0;

//   // Log the cleaned invoice number
//   console.log("Cleaned Invoice Number:", cleanInvoiceNumber(invoiceData.invoiceNumber));


//   return (
//     <div className="invoice print-only max-w-4xl p-6 border border-gray-300 mx-auto bg-white mt-10 mb-10">
//       <h1 className="text-3xl font-bold mb-6 text-center">INVOICE</h1>

//       {/* Header Section */}
//       <div className="invoice-header grid grid-cols-1 md:grid-cols-2 gap-4 mb-8 border-b pb-4">
//         <div className="company-info text-sm">
//           <div className="grid grid-cols-2 gap-x-2">
//             <p className="font-bold">Business name:</p>
//             <p>DockyardTotal Solution</p>
//             <p className="font-bold">Address:</p>
//             <p>No 457/ Colombo</p>
//             <p className="font-bold">Phone number:</p>
//             <p>011-2345678</p>
//             <p className="font-bold">Email:</p>
//             <p>docyard@gmail.com</p>
//           </div>
//         </div>
//         <div className="invoice-details text-sm">
//           <div className="grid grid-cols-2 gap-x-2">
//             <p className="font-bold">Invoice number:</p>
//             <p>{invoiceData.invoiceNumber}</p>
//             <p className="font-bold">Invoice number:</p>

//             <p>{cleanInvoiceNumber(invoiceData.invoiceNumber)}</p>
//             <p className="font-bold">Invoice date:</p>
//             <p>{formatDate(invoiceData.date)}</p>
//           </div>
//         </div>
//       </div>

//       {/* Bill To Section */}
//       <div className="billing-info grid grid-cols-1 md:grid-cols-2 gap-4 mb-8 border-b pb-4">
//         <div className="text-sm">
//           <div className="grid grid-cols-2 gap-x-2">
//             <p className="font-bold">Name:</p>
//             <p>{invoiceData.clientName}</p>
//             <p className="font-bold">Tel No:</p>
//             <p>{invoiceData.mobileNumber}</p>
//           </div>
//         </div>
//       </div>

//       {/* Table Section */}
//       <div className="table w-full mb-8 overflow-x-auto">
//         <table className="min-w-full border-collapse border border-gray-300">
//           <thead className="bg-orange-100 font-bold border-b-2 text-center">
//             <tr>
//               <th className="text-left pl-4 py-2 border border-gray-300">Item</th>
//               <th className="py-2 border border-gray-300">Quantity</th>
//               <th className="py-2 border border-gray-300">Price per unit</th>
//               <th className="text-right pr-4 py-2 border border-gray-300">Amount</th>
//             </tr>
//           </thead>
//           <tbody>
//             {items.length > 0 ? (
//               items.map((item, index) => {
//                 const quantity = Number(item.quantity) || 0; // Convert to number, default to 0
//                 const unitPrice = Number(item.unitPrice) || 0; // Convert to number, default to 0
//                 return (
//                   <tr key={index} className="border-b text-center">
//                     <td className="text-left pl-4 py-2 border border-gray-300">{item.productName}</td>
//                     <td className="py-2 border border-gray-300">{quantity.toFixed(2)}</td>
//                     <td className="py-2 border border-gray-300">{unitPrice.toFixed(2)}</td>
//                     <td className="text-right pr-4 py-2 border border-gray-300">
//                       {(unitPrice * quantity).toFixed(2)}
//                     </td>
//                   </tr>
//                 );
//               })
//             ) : (
//               <tr>
//                 <td colSpan="4" className="text-center py-4">No items found</td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
// {/* Totals Section */}
// <div className="totals text-sm text-right border-t-2 border-gray-300 pt-4 w-full">
//   <div className="grid grid-cols-1 md:grid-cols-2">
//     <div></div>
//     <div className="text-right">
//       <p className="flex justify-between mr-4 md:ml-20">
//         <span>Subtotal:</span> <span>Rs {subtotal.toFixed(2)}</span>
//       </p>

//       {showAdvanceAmount && (
//         <p className="flex justify-between mr-4 md:ml-20">
//           <span>Advance Amount:</span> <span>Rs {advanceAmount.toFixed(2)}</span>
//         </p>
//       )}

//       <p className="flex justify-between mr-4 md:ml-20">
//         <span>Paid Amount:</span> <span>Rs {invoiceData.paidAmount?.toFixed(2) || "0.00"}</span>
//       </p>

//       <p className="flex justify-between mr-4 md:ml-20">
//         <span>Tax ({invoiceData.tax || 0}%):</span> <span>Rs {taxAmount.toFixed(2)}</span>
//       </p>

//       <p className="flex justify-between mr-4 md:ml-20">
//         <span>Fees/discounts:</span> <span>Rs {discountAmount.toFixed(2)}</span>
//       </p>

//       {invoiceData.remainingBalance !== undefined ? (
//         <p className="flex justify-between font-bold text-lg bg-orange-100 px-4 py-2 md:ml-20 mr-2">
//           <span>Remaining Balance:</span> <span>Rs {invoiceData.remainingBalance.toFixed(2)}</span>
//         </p>
//       ) : (
//         <p className="flex justify-between font-bold text-lg bg-orange-100 px-4 py-2 md:ml-20 mr-2">
//           <span>TOTAL:</span> <span>Rs {total.toFixed(2)}</span>
//         </p>
//       )}
//     </div>
//   </div>
// </div>

//       {/* Footer Section */}
//       <div className="footer text-sm mt-8">
//         <p className="font-bold">Terms and conditions</p>
//         <p>Terms and conditions go here</p>
//       </div>

//       {/* Print Button */}
//       <div className="print-button mt-6 print:hidden">
//         <button
//           onClick={handlePrint}
//           className="bg-blue-500 text-white py-2 px-4 rounded-lg shadow hover:bg-blue-700"
//         >
//           Print Invoice
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ViewPort;

import { useLocation } from "react-router-dom";
import { FaFilePdf, FaPrint } from 'react-icons/fa';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const ViewPort = ({ invoiceData: propInvoiceData, onPrint, invoiceRef }) => {
  const { state } = useLocation();
  const invoiceData = propInvoiceData || state?.invoiceData || null;

  if (!invoiceData) {
    return <div className="loading-message">Loading invoice data...</div>;
  }

  const handlePrint = () => {
    if (onPrint) {
      onPrint();
    } else {
      window.print();
    }
  };

  // const handlePDFDownload = () => {
  //   const input = invoiceRef?.current || document.querySelector('.invoice-content');
  //   if (input) {
  //     html2canvas(input, { 
  //       scrollX: 0, 
  //       scrollY: 0, 
  //       useCORS: true, 
  //       scale: 2,
  //       allowTaint: true,
  //       backgroundColor: '#ffffff'
  //     })
  //       .then(canvas => {
  //         const imgData = canvas.toDataURL('image/png');
  //         const pdf = new jsPDF({ 
  //           orientation: 'p', 
  //           unit: 'mm', 
  //           format: 'a4' 
  //         });

  //         const imgWidth = 190;
  //         const pageHeight = 295;
  //         const imgHeight = (canvas.height * imgWidth) / canvas.width;
  //         let heightLeft = imgHeight;

  //         let position = 10;

  //         pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
  //         heightLeft -= pageHeight;

  //         while (heightLeft >= 0) {
  //           position = heightLeft - imgHeight;
  //           pdf.addPage();
  //           pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
  //           heightLeft -= pageHeight;
  //         }

  //         pdf.save(`invoice_${invoiceData.invoiceNumber}.pdf`);
  //       })
  //       .catch(err => console.error('Error capturing invoice:', err));
  //   }
  // };

  // Function to clean invoice number by removing the part after a hyphen


  // const handlePDFDownload = () => {
  //   const input = invoiceRef?.current || document.querySelector('.invoice-content');
  //   const actionButtons = document.querySelector('.invoice-actions');


  //   if (actionButtons) {
  //     actionButtons.style.display = 'none';
  //   }

  //   if (input) {
  //     html2canvas(input, {
  //       scrollX: 0,
  //       scrollY: 0,
  //       useCORS: true,
  //       scale: 2,
  //       allowTaint: true,
  //       backgroundColor: '#ffffff'
  //     })
  //       .then(canvas => {
  //         const imgData = canvas.toDataURL('image/png');
  //         const pdf = new jsPDF({
  //           orientation: 'p',
  //           unit: 'mm',
  //           format: 'a4'
  //         });

  //         const imgWidth = 190;
  //         const pageHeight = 295;
  //         const imgHeight = (canvas.height * imgWidth) / canvas.width;
  //         let heightLeft = imgHeight;

  //         let position = 10;

  //         pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
  //         heightLeft -= pageHeight;

  //         while (heightLeft >= 0) {
  //           position = heightLeft - imgHeight;
  //           pdf.addPage();
  //           pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
  //           heightLeft -= pageHeight;
  //         }

  //         pdf.save(`invoice_${invoiceData.invoiceNumber}.pdf`);
  //       })
  //       .catch(err => console.error('Error capturing invoice:', err))
  //       .finally(() => {
  //         if (actionButtons) {
  //           actionButtons.style.display = 'flex';
  //         }
  //       });
  //   }
  // };


  
  //Modified PDF downloaded according to mobile resposnive
  const handlePDFDownload = () => {
    const input = invoiceRef?.current || document.querySelector('.invoice-content');
    const actionButtons = document.querySelector('.invoice-actions');

    if (actionButtons) {
      actionButtons.style.display = 'none';
    }

    if (input) {
      const originalWidth = input.style.width;
      const originalOverflow = input.style.overf

      input.style.width = '800px';
      input.style.overflow = 'hidden';

      const isMobile = window.innerWidth <= 768;
      const scale = isMobile ? 3 : 2; 

      html2canvas(input, {
        scrollX: 0,
        scrollY: 0,
        useCORS: true,
        scale: scale,
        allowTaint: true,
        backgroundColor: '#ffffff',
        logging: true, 
        windowWidth: 800 
      })
        .then(canvas => {
          const imgWidth = 190; 
          const imgHeight = (canvas.height * imgWidth) / canvas.width;

          const pdf = new jsPDF({
            orientation: imgHeight > 280 ? 'p' : 'p', 
            unit: 'mm',
            format: 'a4'
          });

          pdf.addImage(canvas, 'PNG', 10, 10, imgWidth, imgHeight);
          pdf.save(`invoice_${invoiceData.invoiceNumber}.pdf`);
        })
        .catch(err => {
          console.error('Error generating PDF:', err);
         
        })
        .finally(() => {
          input.style.width = originalWidth;
          input.style.overflow = originalOverflow;

          if (actionButtons) {
            actionButtons.style.display = 'flex';
          }
        });
    }
  };


  const cleanInvoiceNumber = (invoiceNumber) => {
    if (invoiceNumber.includes("-")) {
      return invoiceNumber.split("-")[0];
    }
    return invoiceNumber;
  };

  // console.log("ViewPort Invoice Data:", invoiceData);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? "Invalid date" : date.toISOString().split("T")[0];
  };

  const items = invoiceData.items || [];

  const subtotal = items.reduce((acc, item) => acc + item.unitPrice * item.quantity, 0);
  const discountAmount = (subtotal * (invoiceData.discount || 0)) / 100;
  const taxAmount = (subtotal * (invoiceData.tax || 0)) / 100;
  const total = subtotal - discountAmount + taxAmount;
  const showAdvanceAmount = String(cleanInvoiceNumber(invoiceData.invoiceNumber)) === String(invoiceData.invoiceNumber);
  const advanceAmount = Number(invoiceData.advanceAmount) || 0;

  // console.log("Cleaned Invoice Number:", cleanInvoiceNumber(invoiceData.invoiceNumber));

  return (
    <div className="invoice-wrapper">
      <div className="invoice-content print-only">
        <div className="invoice-header-section">
          <h1 className="invoice-title">INVOICE</h1>
        </div>
        <div className="invoice-header-details">
          <div className="company-info">
            <div className="info-grid">
              <div className="info-row">
                <span className="info-label">Company:</span>
                <span className="info-value">DockyardTotal Solution</span>
              </div>
              <div className="info-row">
                <span className="info-label">Address:</span>
                <span className="info-value">No 457/ Colombo</span>
              </div>
              <div className="info-row">
                <span className="info-label">Phone number:</span>
                <span className="info-value">011-2345678</span>
              </div>
              <div className="info-row">
                <span className="info-label">Email:</span>
                <span className="info-value">docyard@gmail.com</span>
              </div>
            </div>
          </div>
          <div className="invoice-details">
            <div className="info-grid">
              <div className="info-row">
                <span className="info-label">Invoice number:</span>
                <span className="info-value">{invoiceData.invoiceNumber}</span>
              </div>
              <div className="info-row">
                <span className="info-label">Base Invoice number:</span>
                <span className="info-value">{cleanInvoiceNumber(invoiceData.invoiceNumber)}</span>
              </div>
              <div className="info-row">
                <span className="info-label">Invoice date:</span>
                <span className="info-value">{formatDate(invoiceData.date)}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="billing-info">
          <div className="info-grid">
            <div className="info-row">
              <span className="info-label">Name:</span>
              <span className="info-value">{invoiceData.clientName}</span>
            </div>
            <div className="info-row">
              <span className="info-label">Tel No:</span>
              <span className="info-value">{invoiceData.mobileNumber}</span>
            </div>
          </div>
        </div>
        <div className="invoice-table-container">
          <table className="invoice-table">
            <thead>
              <tr>
                <th className="table-header-left">Item</th>
                <th className="table-header-center">Quantity</th>
                <th className="table-header-center">Price per unit</th>
                <th className="table-header-right">Amount</th>
              </tr>
            </thead>
            <tbody>
              {items.length > 0 ? (
                items.map((item, index) => {
                  const quantity = Number(item.quantity) || 0;
                  const unitPrice = Number(item.unitPrice) || 0;
                  return (
                    <tr key={index}>
                      <td className="table-cell-left">{item.productName}</td>
                      <td className="table-cell-center">{quantity.toFixed(2)}</td>
                      <td className="table-cell-center">{unitPrice.toFixed(2)}</td>
                      <td className="table-cell-right">
                        {(unitPrice * quantity).toFixed(2)}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="4" className="table-cell-center no-items">No items found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="invoice-totals">
          <div className="totals-container">
            <div className="total-row">
              <span className="total-label">Subtotal:</span>
              <span className="total-value">Rs {subtotal.toFixed(2)}</span>
            </div>

            {showAdvanceAmount && (
              <div className="total-row">
                <span className="total-label">Advance Amount:</span>
                <span className="total-value">Rs {advanceAmount.toFixed(2)}</span>
              </div>
            )}

            <div className="total-row">
              <span className="total-label">Paid Amount:</span>
              <span className="total-value">Rs {invoiceData.paidAmount?.toFixed(2) || "0.00"}</span>
            </div>

            <div className="total-row">
              <span className="total-label">Tax ({invoiceData.tax || 0}%):</span>
              <span className="total-value">Rs {taxAmount.toFixed(2)}</span>
            </div>

            <div className="total-row">
              <span className="total-label">Fees/discounts ({invoiceData.discount || 0}%):</span>
              <span className="total-value">Rs {discountAmount.toFixed(2)}</span>
            </div>

            {invoiceData.remainingBalance !== undefined ? (
              <div className="total-row final-total">
                <span className="total-label">Remaining Balance:</span>
                <span className="total-value">Rs {invoiceData.remainingBalance.toFixed(2)}</span>
              </div>
            ) : (
              <div className="total-row final-total">
                <span className="total-label">TOTAL:</span>
                <span className="total-value">Rs {total.toFixed(2)}</span>
              </div>
            )}
          </div>
        </div>
        <div className="invoice-footer">
          <p className="footer-title">Terms and conditions</p>
          <p className="footer-content">By using this system, you agree to enter accurate data, keep information confidential, and accept that the system is used at your own risk with terms subject to change.</p>
        </div>
      </div>
      {onPrint && (
        <div className="invoice-actions">
          <button className="action-btn pdf-btn" onClick={handlePDFDownload}>
            <FaFilePdf className="btn-icon" />
            <span>Get PDF</span>
          </button>
          <button className="action-btn print-btn" onClick={handlePrint}>
            <FaPrint className="btn-icon" />
            <span>Print</span>
          </button>
        </div>
      )}
      {!onPrint && (
        <div className="print-button print:hidden">
          <button
            onClick={handlePrint}
            className="standalone-print-btn"
          >
            Print Invoice
          </button>
        </div>
      )}
    </div>
  );
};

export default ViewPort;